export default function ($t) {
  return [
    {
      label: $t("hsr"),
      value: "HSRId",
    },
    {
      label: $t("tdm"),
      value: "TDMId",
    },
    {
      label: $t("kadl"),
      value: "KADLId",
    },
    {
      label: $t("outletType"),
      value: "OutletTypeId",
    },
    {
      label: $t("agency"),
      value: "agencyId",
    },
    {
      label: $t("externalFormat"),
      value: "ExternalFormatId",
    },
    {
      label: $t("channel"),
      value: "ChannelId",
    },
    {
      label: $t("narka"),
      value: "NARKAId",
    },
    {
      label: $t("sipChannel"),
      value: "SIPChannelId",
    },
    {
      label: $t("geoCluster"),
      value: "ClusterId",
    },
    {
      label: $t("addressProgramOrderKasValue"),
      value: "KASValue",
    }
  ];
}

